import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { useTheme } from '@emotion/react';
import { Box, Paper, useMediaQuery } from '@mui/material';

import BackgroundImage from '../assets/images/BackgroundImage.svg';

import { AuthRouter } from '../routers/auth.router';

const Wrapper = ({ Component }) => <Component />;

const AuthLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        backgroundImage: isMobile ? undefined : `url(${BackgroundImage})`,
        backgroundPosition: 'top right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: isMobile ? undefined : theme.spacing(4),
        minHeight: '100vh',
      }}>
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'stretch',
          alignItems: 'stretch',
          gap: 3,
          borderRadius: '0.3rem',
          py: theme.spacing(6),
          px: isMobile ? theme.spacing(3) : theme.spacing(8),
          overflow: 'auto',
          height: isMobile ? '100vh' : undefined,
          width: isMobile ? '100vw' : theme.spacing(66),
        }}>
        <Routes>
          {AuthRouter.map((router, index) => (
            <Route path={router.path} key={`${index}-${router.name}`} element={<Wrapper Component={router.component} />} />
          ))}
        </Routes>
      </Paper>
    </Box>
  );
};

export default AuthLayout;
